import { render, staticRenderFns } from "./CreatedTasksResolvedPage.vue?vue&type=template&id=6bb364e9"
import script from "./CreatedTasksResolvedPage.vue?vue&type=script&lang=js"
export * from "./CreatedTasksResolvedPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports